import React from "react";
import { Calendar, Euro, CreditCard } from "lucide-react";

const STAT_CONFIG = {
  week:         { color: "#3899ec", icon: Calendar,   prefix: "",              labelKey: "week",            totalKey: "week" },
  month:        { color: "#22c55e", icon: Euro,       prefix: "",              labelKey: "month",           totalKey: "month" },
  quarter:      { color: "#8b5cf6", icon: CreditCard, prefix: "Trimestre ",    labelKey: "current_quarter", totalKey: "current_quarter" },
  prev_quarter: { color: "#f59e0b", icon: Calendar,   prefix: "Trimestre préc. ", labelKey: "previous_quarter", totalKey: "previous_quarter" },
};

const StatCard = ({ periodKey, stats, periodFilter, onPeriodClick }) => {
  const cfg = STAT_CONFIG[periodKey];
  if (!cfg) return null;
  const Icon = cfg.icon;
  const isActive = periodFilter === periodKey;
  const statBlock = stats?.[cfg.totalKey];

  return (
    <div
      className={`bg-white rounded-xl border p-4 cursor-pointer transition-all hover:shadow-md ${
        isActive ? `border-[${cfg.color}] ring-2 ring-[${cfg.color}]/20` : "border-[#edf0f4]"
      }`}
      style={isActive ? { borderColor: cfg.color, boxShadow: `0 0 0 2px ${cfg.color}33` } : {}}
      onClick={() => onPeriodClick(periodKey)}
      data-testid={`stat-${periodKey.replace("_", "-")}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${cfg.color}1a` }}>
          <Icon size={20} style={{ color: cfg.color }} />
        </div>
        <div>
          <p className="text-xs text-[#8fa4b5] uppercase tracking-wide">
            {cfg.prefix}{statBlock?.label || periodKey}
          </p>
          <p className="text-xl font-bold" style={{ color: cfg.color }} data-testid={`${periodKey.replace("_", "-")}-total`}>
            {statBlock?.total?.toLocaleString("fr-BE", { minimumFractionDigits: 2 }) || "0,00"} €
          </p>
        </div>
      </div>
      {isActive && (
        <p className="text-xs mt-2 text-center" style={{ color: cfg.color }}>
          Cliquez pour retirer le filtre
        </p>
      )}
    </div>
  );
};

export const CashbookStatsCards = ({ stats, periodFilter, onPeriodClick }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    {["week", "month", "quarter", "prev_quarter"].map((key) => (
      <StatCard key={key} periodKey={key} stats={stats} periodFilter={periodFilter} onPeriodClick={onPeriodClick} />
    ))}
  </div>
);
